<template>
  <div>
    <content-card v-if="screen == 'inputEmail'">
      <template v-slot:header>
        <div class="subtitle">{{ t("send_report.email.input") }}</div>
      </template>
      <template v-slot:description>
        <div class="d-flex justify-content-center flex-column align-items-center g-24">
          <div style="width: 397px">
            <input-form
              :id="'email'"
              :value="email"
              :disabled="false"
              :placeholder="t('send_report.email.placeholder') + 'email@address.com'"
              @updateModel="updateEmail"
            />
          </div>
          <div class="button-container g-24">
            <button type="button" class="continue-button" :disabled="disabled" @click="screen = 'confirmEmail'">
              {{ t("button.send") }}
            </button>
            <button class="continue-button-clear fwd-orange" @click="$emit('back')">{{ t("button.back") }}</button>
          </div>
        </div>
      </template>
    </content-card>
    <content-card v-else>
      <template v-slot:header>
        <div class="subtitle">{{ t("button.confirm") }}</div>
      </template>
      <template v-slot:description>
        <div class="d-flex justify-content-center flex-column align-items-center g-24">
          <div class="text">
            <div>{{ t("send_report.email.check") }}</div>
            <div>{{ email }}</div>
          </div>

          <div class="button-container g-24">
            <button type="button" class="continue-button" :disabled="loadingSending" @click="sendReport">
              <div v-if="!loadingSending">{{ t("button.send") }}</div>
              <div v-else class="d-flex justify-content-around">
                <img src="../assets/spinner.svg" alt="" class="spinner" />
                {{ t("send_report.sending") }}
              </div>
            </button>
            <button class="continue-button-clear fwd-orange" :disabled="loadingSending" @click="screen = 'inputEmail'">
              {{ t("button.back") }}
            </button>
          </div>
        </div>
      </template>
    </content-card>
  </div>
</template>

<script>
import InputForm from "@/components/input-form.vue";
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { locale, t } = useI18n();
    return {
      locale,
      t,
    };
  },
  components: { InputForm },
  props: {
    loadingSending: Boolean,
  },
  emits: ["back", "sendReport"],
  data() {
    return {
      disabled: true,
      email: "",
      screen: "inputEmail",
    };
  },
  methods: {
    checkDisabled() {
      const emailValid = this.validateEmail(this.email);
      this.disabled = !emailValid;
    },
    validateEmail(email) {
      // eslint-disable-next-line
      let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;

      if (!reg.test(email)) {
        return false;
      } else {
        return true;
      }
    },
    updateEmail(email) {
      this.email = email;
      this.checkDisabled();
    },
    sendReport() {
      this.$emit("sendReport", this.email);
    },
  },
};
</script>

<style scoped>
.button-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.text {
  text-align: center;
  font-size: 25px;
  font-weight: 450;
}
@media (max-width: 767px) {
  .text {
    font-size: 14px;
  }
}
</style>
